export default () => ({
    active: true,

    toggle() { this.active = !this.active },
    isActive() { return this.active === false },
})